import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=ca0bfc98&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=ca0bfc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.97.1_webpack-cli@4.10.0___handlebars@4.7_53d190cee4bf45caad478252ee7625a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0bfc98",
  null
  
)

export default component.exports